var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.951 136.588C304.358 124.519 344.445 88.2261 364.703 65.9712L459.286 170.826C449.357 198.217 400.083 226.464 376.686 237.163C356.486 242.641 359.995 295.796 369.839 321.903C390.039 362.989 373.12 413.633 364.703 434.89C332.519 510.899 291.661 483.394 275.255 460.14C249.576 418.37 235.025 380.108 238.877 339.878L258.136 214.052C262.245 168.173 280.391 143.293 288.951 136.588Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M291.833 50.3299C248.059 57.5447 274.759 100.826 293.58 121.565L313.198 113.17C318.635 70.0898 303.988 48.3265 291.833 50.3299Z",
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.245 86.5138C200.397 125.855 257.167 129.849 282.989 134.842L293.008 117.488C272.843 82.0456 238.659 73.6744 229.245 86.5138Z",
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M367.909 65.9712C347.652 88.2261 307.564 124.519 292.157 136.588C283.597 143.293 265.451 168.173 261.342 214.052L242.083 339.878C238.231 380.108 252.783 418.37 278.462 460.14C294.867 483.394 335.725 510.899 367.909 434.89C376.326 413.633 393.245 362.989 373.045 321.903C363.201 295.796 359.692 242.641 379.893 237.163C403.289 226.464 452.564 198.217 462.493 170.826",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M335.897 364.273C335.041 384.959 340.177 428.384 367.568 436.601",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293.639 410.91C297.645 431.223 312.793 472.243 341.346 473.827",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M231.283 316.595C222.101 190.178 273.691 132.36 310.823 107.718C314.648 105.179 319.631 108.059 320.218 112.613C327.35 167.933 389.558 197.523 421.392 210.953C426.039 212.914 426.306 219.388 421.964 221.952C359.893 258.589 366.61 286.732 377.788 311.408C379.901 316.072 375.678 321.232 370.635 320.339C328.385 312.851 264.698 318.374 238.241 322.173C234.756 322.673 231.538 320.106 231.283 316.595Z",
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M261.77 166.546C279.175 190.371 336.41 233.91 426.114 217.476",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M400.008 228.175C382.603 251.999 325.368 295.539 235.663 279.105",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M312.7 109.625C309.133 136.16 309.618 194.365 340.09 214.908",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.249 176.372L131.069 110L144.552 163.351L128.069 168.5L189.432 238.547L172.876 181.121L189.249 176.372Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.859 259.501L66.9999 273.741L114.825 288.197L111.123 303.432L194.331 288.434L141.899 274.464L145.859 259.501Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/정형외과_관절염.8947d860c8ee7ab9940b870aa20dde28.svg";
export { ForwardRef as ReactComponent };